export default __webpack_public_path__ + "static/datafund-4ded9add362a9f102f956f278e498423.png";